module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQJJREFUSEvtlTFqAkEUhr9fvEEuEDyFWNmEXCC9kMpTBEPwBl4gkC5V6lh4AgmkDp4glVUS9A8LI7jj6O4oCoYsbLP7/vnmzZv3P3HkR0den9MCbH8ArSirsaSrOFPbXeAVaK79WwK3kh5X30oZ2DYwCe8q5k3SSwJwAfQjwAAYSLrfBSgF5NQobPCPA4qijVJnXueobG/oT3tN6+wyNyaZge1n4CZjsS+gI2kaa7YBroF2BuA71G5eC5CxcGVo3MlF+79L+qxUJgKCfZT0MeAntPpwT8CGPuVF/1ax0+wWQOOAeVBI7yQ9bLPrHnAZAXLmQTFwniTNkoB9bk6V5vzN7hflT5IZ7UfYKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/binding/img/2.png
// module id = DGLX
// module chunks = 59